import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const Wrapper = styled.div`
  margin-top: 24px;
  max-width: 562px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
  row-gap: 24px;
`;

export const Title = styled.h1`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
  margin: 0 0 16px 0;

  @media (min-width: ${DEVICE.mobileXL}) {
    font-size: 28px;
    line-height: 36px;
  }
`;

export const Subtitle = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontSecondary : '#6B7280'};
`;

export const FormContainer = styled.div`
  margin-top: 24px;
  width: 100%;
  max-width: 522px;
`;
